// client/src/index.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ProjectProvider } from './contexts/ProjectContext';
import { CreditProvider } from './contexts/CreditContext';
import { OrgProvider } from './contexts/OrgContext';
import './styles/main.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <OrgProvider>
          <CreditProvider>
            <ProjectProvider>
              <App />
            </ProjectProvider>
          </CreditProvider>
        </OrgProvider>
      </AuthProvider>
    </BrowserRouter>
    <ToastContainer />
  </React.StrictMode>
);

